import React from "react";

const PlayIcon = ({ width = "18", height = "18" }) => {
  return (
    <svg
      aria-hidden
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 16.2029C0 16.8494 0.275753 17.3629 0.827258 17.7433C1.13154 17.9144 1.45483 18 1.79715 18C2.06339 18 2.32964 17.9334 2.59588 17.8003L17.0016 10.6117C17.2868 10.4596 17.5246 10.2409 17.7147 9.95563C17.9049 9.67036 17.9905 9.34707 17.9715 8.98574C17.9525 8.62441 17.8669 8.31062 17.7147 8.04437C17.5626 7.77813 17.3249 7.55943 17.0016 7.38827L2.59588 0.199683C2.32964 0.066561 2.06339 0 1.79715 0C1.47385 0 1.15055 0.0855785 0.827258 0.256735C0.275753 0.618067 0 1.13154 0 1.79715V16.2029Z"
        fill="#F6F8FA"
      />
    </svg>
  );
};

export default PlayIcon;
